import { walletStatusConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  params: null,
  fetched: false,
  response: null,
  error: null
};

export const walletStatus = (state = initialState, action) => {
  switch (action.type) {
    case walletStatusConstants.GET_WALLETSTATUS_REQUEST:
      return {
        ...state,
        response: null,
        params: action.params,
        fetching: true
      };
    case walletStatusConstants.GET_WALLETSTATUS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case walletStatusConstants.GET_WALLETSTATUS_FAILURE:
      return {
        ...state,
        response: null,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case walletStatusConstants.GET_WALLETSTATUS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
